export * from './patient-shortcut.component';
